<template>
	<div id="Message" class="fullscreen-centered always-on-top dark-stars">
		<div class="closeButton"><a href="#" v-if="closeable" v-on:click="CloseMessage"><i class="fas fa-times"></i></a></div>
		<div>
			<Logo/>
			<div class="message">
				<h2 v-html="title"></h2>
				<div v-html="content"></div>
			</div>
		</div>
	</div>
</template>

<script>
	import Logo from "@/components/Logo.vue";

	export default {
		name: 'Message',
		components: {
			Logo
		},
		data() {
			return {
				renderCount: 0,
				title: '',
				content: '',
				closeable: false
			}
		},
		mounted() {
			this.$scanner.message._rerender = this.ReRender
			this.$scanner.message._update = this.Update
			this.Update()
		},
		methods: {
			ReRender() { this.renderCount = ++this.$scanner.message.renderCount },
			Update() {
				this.renderCount = this.$scanner.message.renderCount
				this.title = this.$scanner.message.title
				this.content = this.$scanner.message.content
				this.closeable = this.$scanner.message.closeable
				this.ReRender()
			},
			CloseMessage(e) {
				if (e) { e.preventDefault(); }
				this.$scanner.message.close();
			}
		}
	}
</script>

<style>
	#Message .message>h2 { text-transform: uppercase; color: var(--color-red); }
</style>